export const DashboardName = 'App Lane';
export const DashboardTagLine = 'Deployment made easy...';
